import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "@carbon/icons-react";

type GoBackArrowProps = {
  absolute?: boolean;
  stylesAdded?: string;
  isOffer?: boolean;
};

const GoBackArrow = ({ isOffer = false }: GoBackArrowProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const isMaterialOffer = location.pathname.includes("/material/offer");
  return (
    <button
      aria-label={t("cta.goBack")}
      onClick={() => {
        isMaterialOffer
          ? navigate("/material/offers")
          : isOffer
            ? navigate("/biddings")
            : navigate(-1);
      }}
    >
      <ArrowLeft size={24} aria-hidden="true" />
    </button>
  );
};

export default GoBackArrow;
